// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"42e31836","983":"11385033"}[chunkId] + ".chunk.js";
};